import { render } from "./GitPushCommandCopy.vue?vue&type=template&id=4fed3ae0"
import script from "./GitPushCommandCopy.vue?vue&type=script&lang=js"
export * from "./GitPushCommandCopy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__